/*
 * Copyright (c) 2022 CalAmp Corp. All Rights Reserved
 */
import {BulkActionType} from '@ion/core/src/types/entities';

export interface BulkAction {
  title: string;
  type: BulkActionType;
}

export type BulkActions = BulkAction[];

// Defines the Group Assignment Actions
export enum GroupAssignmentActions {
  Add = 'add',
  AddNew = 'addNew',
  Remove = 'remove',
  Replace = 'replace',
  ReplaceNew = 'replaceNew'
};

export enum GroupAssignmentActionStatus {
  Hold = 'hold',
  Start = 'start',
  InProgress = 'inProgress',
  Success = 'success',
  Failed = 'failed'
};
